import summaryDark from "./summary_icon_14px_dark.png";
import summaryLight from "./summary_icon_14px_light.png";

type SummaryIconProps = {
  color?: "light" | "dark";
};

const SUMMARY_IMAGES: Record<"light" | "dark", string> = {
  light: summaryLight,
  dark: summaryDark,
};

export const SummaryIcon = ({ color }: SummaryIconProps) => (
  <img src={SUMMARY_IMAGES[color || "light"]} alt="Summary icon" />
);
